<script>
import { Overlay } from 'trading-vue-js'

export default {
    name: 'StochRsi',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Hardik and Prit', 
                version: '1.0.0',
                desc: 'Stochastic RSI',
                preset: {
                    name: 'StochRSI',
                    side: 'offchart',
                    settings: {
                        upper: 80,
                        lower: 20,
                        lineWidth: 0.75,
                        kColor: '#3782f2',
                        dColor: '#f48709',
                        bandColor: '#ddd',
                        backColor: '#381e9c16'
                    }
                }
            }
        },
        draw(ctx) {
            const layout = this.$props.layout
            const upper = layout.$2screen(this.sett.upper || 80)
            const lower = layout.$2screen(this.sett.lower || 20)

            // %K line
            ctx.lineWidth = this.line_width
            ctx.strokeStyle = this.k_color
            ctx.beginPath()
            for (var p of this.$props.data) {
                let x = layout.t2screen(p[0])
                let y = layout.$2screen(p[1])
                ctx.lineTo(x, y)
            }
            ctx.stroke()

            // %D line
            ctx.lineWidth = this.line_width
            ctx.strokeStyle = this.d_color
            ctx.beginPath()
            for (var p of this.$props.data) {
                let x = layout.t2screen(p[0])
                let y = layout.$2screen(p[2])
                ctx.lineTo(x, y)
            }
            ctx.stroke()

            // Bands & Background
            ctx.strokeStyle = this.band_color
            ctx.setLineDash([5])
            ctx.beginPath()

            // Background fill
            ctx.fillStyle = this.back_color
            ctx.fillRect(0, upper, layout.width, lower - upper)

            // Upper band
            ctx.moveTo(0, upper)
            ctx.lineTo(layout.width, upper)

            // Lower band
            ctx.moveTo(0, lower)
            ctx.lineTo(layout.width, lower)

            ctx.stroke()
            ctx.setLineDash([])
        },
        use_for() { return ['StochRsi'] },
        y_range(hi, lo) {
            return [
                Math.max(hi, this.sett.upper || 80),
                Math.min(lo, this.sett.lower || 20)
            ]
        },
        calc() {
            return {
                props: {
                    rsiLen: { def: 14, text: 'RSI Length' },
                    stochLen: { def: 14, text: 'Stochastic Length' },
                    kSmooth: { def: 3, text: 'K' },
                    dSmooth: { def: 3, text: 'D' },
                },
                update: `
                    let r = rsi(close, rsiLen)
                    let k = sma(stoch(r, r, r, stochLen), kSmooth)
                    let d = sma(k, dSmooth)
                    return [k[0], d[0]]
                `
            }
        }
    },
    computed: {
        sett() { return this.$props.settings },
        line_width() { return this.sett.lineWidth || 0.75 },
        k_color() { return this.sett.kColor || '#3782f2' },
        d_color() { return this.sett.dColor || '#f48709' },
        band_color() { return this.sett.bandColor || '#ddd' },
        back_color() { return this.sett.backColor || '#381e9c16' }
    }
}
</script>
